import React, { useEffect, useState } from 'react';
import './Styles.css';
import { formatMessage } from '../../Localization/formatMessage';
import Messages from '../../Localization/Messages';
import { ServiceClient } from '../../Services/ServiceClient';
import LoaderComponent from '../../Elements/ids/Loader';
import { useGlobalContext } from '../../context/GlobalContext';
import { updateBreadcrumbs } from './Functions';
import { PresentationMode } from '../../Enums/PresentationMode';
import ConversionTable from './ConversionTable';
import Notifications from './Notifications';
import BreadcrumbRow from '../../Elements/Breadcrumbs';

const AgentConversionPage = () => {
  const { addBreadcrumbs } = useGlobalContext();
  const [pageMode, setPageMode] = useState(PresentationMode.Loading);
  const [agentConversions, setAgentConversions] = useState(null);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    ServiceClient.getAgentCodeConversions(
      data => {
        setAgentConversions(data);
        setPageMode(PresentationMode.View);
      },
      () => {
        setPageMode(PresentationMode.Error);
      }
    );
    updateBreadcrumbs(addBreadcrumbs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="agentConversionPage-container">
      <BreadcrumbRow />
      <Notifications notifications={notifications} setNotifications={setNotifications} />
      <div className="content">
        <h2>{formatMessage(Messages.agentConversionPage_title)}</h2>
        {pageMode === PresentationMode.Loading ? (
          <LoaderComponent />
        ) : pageMode === PresentationMode.View ? (
          <>
            <h3>{formatMessage(Messages.agentConversionPage_statistics)}</h3>
            <div className="agentConversionPage-statisticsTable-container">
              <div className="common-table-row agentConversionPage-statisticsTable-row headerRow">
                <div>{formatMessage(Messages.agentConversionPage_channelNameInUserMetadata)}</div>
                <div>{formatMessage(Messages.agentConversionPage_glCode)}</div>
                <div>{formatMessage(Messages.agentConversionPage_channelNameInWayPoint)}</div>
                <div>{formatMessage(Messages.agentConversionPage_agentsInUserMetadata)}</div>
                <div>{formatMessage(Messages.agentConversionPage_convertedAgentsToWayPoint)}</div>
                <div>{formatMessage(Messages.agentConversionPage_convertedAgentsInRenewalStep)}</div>
              </div>
              {agentConversions?.map((x, index) => (
                <div
                  className={`common-table-row agentConversionPage-statisticsTable-row ${
                    index % 2 === 1 ? 'common-table-evenRow' : ''
                  }`}
                  key={index}>
                  <div>{x.channelNameInUserMetadata}</div>
                  <div>{x.glCode}</div>
                  <div>{x.channelNameInWayPoint}</div>
                  <div>{x.conversions?.length}</div>
                  <div>{x.conversions?.filter(x => !!x.newCode).length}</div>
                  <div>{x.conversions?.filter(x => x.isFutureChangeActive && x.newCode).length}</div>
                </div>
              ))}
            </div>

            <h3>{formatMessage(Messages.agentConversionPage_convertedAgentsTitle)}</h3>
            <ConversionTable
              agentConversions={agentConversions}
              setAgentConversions={setAgentConversions}
              setNotifications={setNotifications}
            />
          </>
        ) : null}
      </div>
    </div>
  );
};

export default AgentConversionPage;
